import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { LoginOverride, BaseOverride } from 'Overrides/Authentication';
import Unauthenticated from 'Components/ComponentLibrary/Templates/Unauthenticated';
import { useNewLoginContext } from '../NewLoginContext';
import MultiFactorAuth from './Layouts/MultiFactorAuth';
import MultiFactorAuthOverride from './Layouts/MultiFactorAuth/MetaOverrideSet';
import AuthAuthenticator from './Layouts/AuthAuthenticator';
import AuthAuthenticatorOverride from './Layouts/AuthAuthenticator/MetaOverrideSet';
import User from './Layouts/User';
import Login from './Layouts/Login';
import Default from './Layouts/Default';
import AuthenticationForm from './AuthenticationForm';

const styles = (theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(0, 2),
  },
});

const AUTH_LAYOUTS = {
  authLogin: 'AuthPassword',
  authPasswordReset: 'AuthToken',
  authMultiFactor: 'AuthLoginMultiFactor',
  authAuthenticator: 'AuthTotp',
  user: 'user',
};

const getLayout = (headResourceType) => {
  switch (headResourceType) {
    case AUTH_LAYOUTS.user:
      return {
        layout: User,
      };
    case AUTH_LAYOUTS.authMultiFactor:
      return {
        layout: MultiFactorAuth,
        metaOverrideSet: MultiFactorAuthOverride,
      };
    case AUTH_LAYOUTS.authAuthenticator:
      return {
        layout: AuthAuthenticator,
        metaOverrideSet: AuthAuthenticatorOverride,
      };
    case AUTH_LAYOUTS.authLogin:
      return {
        layout: Login,
        metaOverrideSet: LoginOverride,
      };
    default:
      return {
        layout: Default,
        metaOverrideSet: BaseOverride,
      };
  }
};

const FormHolder = ({
  className,
  classes,
}) => {
  const { authCollection } = useNewLoginContext();
  const authResource = authCollection?.resources().head();
  const { layout, metaOverrideSet } = getLayout(authResource?.type());

  return (
    <Unauthenticated>
      <AuthenticationForm
        test={'login-form'}
        className={classNames(classes.root, className)}
        layout={layout}
        collection={authCollection}
        metaOverrideSet={metaOverrideSet}
      />
    </Unauthenticated>
  );
};

FormHolder.defaultProps = {
  className: '',
};

FormHolder.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormHolder);
